(function () {
  function eligible(state, sessionSeen, now, issue, path) {
    return !!state && !sessionSeen && path === '/' && state.muted !== true;
  }
  if (typeof module !== 'undefined') module.exports = { eligible };
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    const invitation = root.querySelector('[data-invitation]');
    const launcher = root.querySelector('[data-launcher]');
    const preference = root.querySelector('[data-preference]');
    const storageNote = root.querySelector('[data-storage-note]');
    const issue = root.dataset.issue;
    const key = root.dataset.preview === 'true' ? 'hg-bulletin-preview-v1' : 'hg-bulletin-v1';
    const sessionKey = key + ':auto-reader-v2';
    let state = {}, storageOK = false, sessionSeen = false, opener = null, previousOverflow = '';
    let automaticDone = false, autoTimer = null, retries = 0;
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '{}');
      if (saved && typeof saved === 'object' && !Array.isArray(saved)) state = saved;
    } catch (_) {}
    try { localStorage.setItem(key, JSON.stringify(state)); storageOK = true; } catch (_) {}
    try { sessionSeen = sessionStorage.getItem(sessionKey) === 'seen'; } catch (_) {}
    function persist() {
      if (!storageOK) return;
      try { localStorage.setItem(key, JSON.stringify(state)); }
      catch (_) { storageOK = false; if (storageNote) storageNote.hidden = false; }
    }
    function seen() {
      const previous = Array.isArray(state.seen) ? state.seen : [];
      state.seen = [...new Set([...previous, issue])].slice(-12);
      persist();
    }
    function finishAutomatic() {
      automaticDone = true;
      if (autoTimer !== null) clearTimeout(autoTimer);
      autoTimer = null;
      sessionSeen = true;
      try { sessionStorage.setItem(sessionKey, 'seen'); } catch (_) {}
    }
    function expire() {
      root.querySelectorAll('[data-expires]').forEach(story => {
        const timestamp = Date.parse(story.dataset.expires);
        if (Number.isFinite(timestamp) && timestamp <= Date.now()) story.hidden = true;
      });
      const stories = [...root.querySelectorAll('[data-story]')];
      const active = stories.some(story => !story.hidden);
      stories.forEach(story => story.classList.remove('hg-b-featured'));
      stories.find(story => !story.hidden)?.classList.add('hg-b-featured');
      if (!active && dialog?.open) dialog.close();
      root.hidden = !active;
      return active;
    }
    if (!expire() || !dialog || typeof dialog.showModal !== 'function') return;
    launcher.hidden = false;
    preference.checked = state.muted === true;
    if (!storageOK && storageNote) storageNote.hidden = false;
    function dismissInvitation() {
      const hadFocus = invitation.contains(document.activeElement);
      invitation.hidden = true;
      finishAutomatic(); seen();
      if (hadFocus) launcher.focus();
    }
    function open(event) {
      if (event) event.preventDefault();
      if (dialog.open || !expire()) return;
      opener = document.activeElement;
      invitation.hidden = true;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      finishAutomatic(); seen();
      dialog.querySelector('[data-close]').focus({ preventScroll: true });
    }
    function close() { if (dialog.open) dialog.close(); }
    root.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', open));
    root.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', close));
    root.querySelector('[data-dismiss]').addEventListener('click', dismissInvitation);
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      seen();
      if (opener && opener !== document.body && opener.isConnected && opener.getClientRects().length) opener.focus({ preventScroll: true });
      else if (!root.hidden) launcher.focus({ preventScroll: true });
      else {
        const main = document.querySelector('main');
        if (main) { const prior = main.getAttribute('tabindex'); main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); if (prior === null) main.removeAttribute('tabindex'); else main.setAttribute('tabindex', prior); }
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    preference.addEventListener('change', () => { state.muted = preference.checked; persist(); });
    function schedule(delay) {
      if (!automaticDone && autoTimer === null) autoTimer = setTimeout(autoOpen, delay);
    }
    function autoOpen() {
      autoTimer = null;
      if (automaticDone || !root.isConnected) return;
      if (storageOK) {
        try {
          const saved = JSON.parse(localStorage.getItem(key) || '{}');
          if (saved && typeof saved === 'object' && !Array.isArray(saved)) state = saved;
        } catch (_) {}
      }
      try { sessionSeen = sessionSeen || sessionStorage.getItem(sessionKey) === 'seen'; } catch (_) {}
      const path = root.dataset.homepage === 'true' ? '/' : location.pathname;
      if (!eligible(state, sessionSeen, Date.now(), issue, path)) { automaticDone = true; return; }
      if (document.hidden || !expire()) return;
      const anotherModal = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(el => el !== dialog && !el.closest('details:not([open])') && el.getBoundingClientRect().width > 0 && el.getBoundingClientRect().height > 0 && getComputedStyle(el).visibility !== 'hidden');
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      if (anotherModal || editing) {
        if (++retries < 30) schedule(1000);
        else automaticDone = true;
        return;
      }
      preference.checked = state.muted === true;
      open();
    }
    schedule(900);
    root.querySelector('[data-preview-invite]')?.addEventListener('click', () => { if (expire()) invitation.hidden = false; });
    root.querySelector('[data-preview-read]')?.addEventListener('click', open);
    document.addEventListener('visibilitychange', () => {
      expire();
      if (!document.hidden) schedule(300);
    });
  }
  document.querySelectorAll('[data-hg-bulletin]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-hg-bulletin]').forEach(init));
})();
